// @core/api/endpoints/task/unschedule_task.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Unschedule task
 * Removes the scheduled time block from a task, freeing the assignee's calendar. The task remains active but without a planned work time.
 */
export async function UnscheduleTask(
  task_id: string,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/schedule`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.delete<TaskResponse>(requestPath, requestOptions);
}
